import { PropsWithChildren } from 'react';
import { Container, Typography } from '@material-ui/core';

export function RedisAnalysisContainer(props: PropsWithChildren) {
  return (
    <Container>
      <Typography variant="h4">Redis Analysis & Maintenance</Typography>
      <ul style={{ paddingLeft: '14px' }}>
        <li>
          <Typography variant="body1">
            Identify, display, and group largest patterns by size.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Displays human-readable output including key size, name, patterns,
            storage, and saves data to json file.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Helps free memory, prevent alerts, and manage patterns.
          </Typography>
        </li>
      </ul>
      {props.children}
    </Container>
  );
}
